import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../common/NavBar";
import Footer from "../common/Footer";
import { Helmet } from 'react-helmet-async';

const About = () => {
  return (
    <div>
      <Helmet>
        <title>About</title>
      </Helmet>
      <div className="site-header header-s1 is-sticky">
        <Navbar />
        {/* Banner/Slider */}
        <div className="page-head section row-vm light has-bg-image">
          <div
            className="imagebg bg-image-loaded"
            style={{
              backgroundImage: `url(${require("../../assets/images/page-inside-bg.jpg")})`,
            }}
          >
            <img
              src={require("../../assets/images/page-inside-bg.jpg")}
              alt="cta-bg"
            />
          </div>
          <div className="container">
            <div className="row text-center">
              <div className="col-md-12">
                <h2>About Us</h2>
                <div className="page-breadcrumb">
                  <ul className="breadcrumb">
                    <li>
                      <Link to="/">Home</Link>
                    </li>
                    <li class="active">
                      <span>About Us</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* #end Banner/Slider */}
      </div>

      {/*Section */}
      <div className="section section-pad">
        <div className="container">
          <div className="row row-vm">
            <div className="col-md-5 res-m-bttm">
              <div className="text-block text-left">
                <h2>
                  About <span style={{ color: "#1c4b82" }}>Afc Trades</span>
                </h2>
                <p>
                  Our goal was to build a better Forex trading location where traders can acquire a full range of global market items.
                  One of the main reasons traders select AFC Trades is the simplicity of being able to trade CFDs across Forex, Shares, Bonds,
                  and Digital Currencies from a single account.
                </p>
                <p>
                  Our comprehensive awareness of what traders require sets us apart from our competition.
                  We've discovered that the right balance of pricing, execution speed, cutting-edge platforms,
                  product diversity, customer service, and market intelligence gives our clients the courage to trade.
                  Our clients' needs are a primary priority for us as an international forex broker.
                  We are one of the best forex brokers in the world due to our unwavering dedication to perfection.
                </p>

              </div>
            </div>
            <div className="col-md-6 col-md-offset-1">
              <div className="video-block round">
                <img
                  src={require("../../assets/images/video-md-a.jpg")}
                  alt="CryptoCoin Overview"
                  className="img-shadow"
                />
                <Link
                  to="https://www.youtube.com/watch?v=N6NscwzbMvI"
                  className="video-play"
                >
                  <span className="pe pe-7s-play"></span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*End Section */}

      {/*Section */}
      <div className="section section-pad bg-grey">
        <div className="container">
          <div className="section-head">
            <div className="row text-center">
              <div className="col-md-6 col-md-offset-3 col-sm-8 col-sm-offset-2">
                <h2 className="heading-section">Why Choose Us</h2>
                <p>
                  Discover why thousands trust us as their forex trading
                  partner. We offer unparalleled service, robust security, and
                  user-friendly tools to enhance your trading experience.
                </p>
              </div>
            </div>
          </div>
          <div className="gaps size-3x"></div>
          <div className="row text-center">
            <div className="col-md-3 res-m-bttm-lg">
              <div className="box-alt">

                <h4>Narrower Spreads from 0.0 Pips</h4>
                <p>
                  AFC Trades consistently offers some of the industry's tightest spreads.
                  Trades start at 0.0 pips on major currency pairs.
                </p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="box-alt">

                <h4>Row Prices</h4>
                <p>
                  You can access organisational liquidity with no price manipulation, trading desks, or requotes.
                </p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="box-alt">

                <h4>Fast Execution</h4>
                <p>
                  With a latency of less than 40 milliseconds, this trade performance is award-winning.
                  This service is provided by our Equinix NY4 facility server cluster.
                </p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="box-alt">

                <h4>Absence of Restrictions</h4>
                <p>
                  AFC Trades is known for having some of the tightest spreads in the industry.
                  Trade starts at 0.0 pips on major currency pairs.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*End Section */}

      {/*Section */}
      <div className="section section-pad">
        <div className="container">
          <div className="row row-vm">
            <div className="col-md-6 col-md-offset-0 ">
              <div className="text-block text-left">
                <h2>A quick look at the company:</h2>
                <ul>
                  <li>Forex, stock CFDs, indices, commodities, and cryptocurrencies are examples of financial instruments.</li>
                  <li>Tight raw spreads available from 0.0 pips.</li>
                  <li>Leverage up to 500:1.</li>
                  <li>Global markets with over 10,000 products available.</li>
                  <li>AFC Trades Multi Platform support.</li>
                  <li>Only a $200 deposit is required to begin.</li>
                  <li>No requotes and no dealing desks.</li>
                  <li>No trading limits, ideal for EAs.</li>
                  <li>Retail client funds are segregated.</li>
                  <li>Award-winning multilingual support available 24/7.</li>
                  <li>Recognized globally with over 40 industry awards.</li>
                  <li>IBs and Affiliates gain access to industry-leading relationship opportunities.</li>
                </ul>
              </div>
            </div>
            <div className="col-md-5">
              <div className="round mgr--30 res-m-bttm">
                <img
                  src={require("../../assets/images/photo-md-a.jpg")}
                  alt="photo-md"
                  className="img-shadow"
                />
              </div>
            </div>

          </div>
        </div>
      </div>
      {/*End Section */}

      {/* Section */}
      <div class="section section-pad cta-section light has-bg dark-filter">
        <div class="imagebg has-parallax">
          <img src={require("../../assets/images/cta-bg.jpg")} alt="cta-bg" />
        </div>
        <div class="container">
          <div class="row text-center">
            <div class="col-md-8 col-md-offset-2">
              <h3>
                Ready to take your first step into the world of cryptocurrency?
              </h3>
              <Link to="#" class="btn btn-md">
                Get Started Now
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* End Section */}

      {/* Section */}
      {/* <div className="section section-pad">
        <div className="container">
          <div className="section-head">
            <div className="row text-center">
              <div className="col-md-6 col-md-offset-3 col-sm-8 col-sm-offset-2">
                <h2 className="heading-section">Meet Our Team</h2>
                <p>
                  Our dedicated team of Forex Trading experts and industry
                  leaders is committed to helping you succeed in the digital
                  asset market.
                </p>
              </div>
            </div>
          </div>
          <div className="gaps size-3x"></div>
          <div className="row text-center">
            <div className="col-md-4 col-md-offset-0 col-sm-8 col-sm-offset-2 res-m-bttm">
              <div className="team-member">
                <div class="team-thumb">
                  <img
                    src={require("../../assets/images/team-thumb-a.jpg")}
                    alt="team-thumb"
                  />
                  <div class="team-thumb-overlay">
                    <ul class="team-social">
                      <li>
                        <Link to="#">
                          <span class="fa fa-linkedin"></span>
                        </Link>
                      </li>
                      <li>
                        <Link to="#">
                          <span class="fa fa-twitter"></span>
                        </Link>
                      </li>
                      <li>
                        <Link to="#">
                          <span class="fa fa-envelope"></span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="team-info">
                  <h5 class="team-name">John Mathews</h5>
                  <span class="team-title">Blockchain Strategist</span>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-md-offset-0 col-sm-8 col-sm-offset-2 res-m-bttm">
              <div class="team-member">
                <div class="team-thumb">
                  <img
                    src={require("../../assets/images/team-thumb-b.jpg")}
                    alt="team-thumb"
                  />
                  <div class="team-thumb-overlay">
                    <ul class="team-social">
                      <li>
                        <Link to="#">
                          <span class="fa fa-linkedin"></span>
                        </Link>
                      </li>
                      <li>
                        <Link to="#">
                          <span class="fa fa-twitter"></span>
                        </Link>
                      </li>
                      <li>
                        <Link to="#">
                          <span class="fa fa-envelope"></span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="team-info">
                  <h5 class="team-name">Sophia Williams</h5>
                  <span class="team-title">Technical Lead</span>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-md-offset-0 col-sm-8 col-sm-offset-2 res-m-bttm">
              <div className="team-member">
                <div class="team-thumb">
                  <img
                    src={require("../../assets/images/team-thumb-c.jpg")}
                    alt="team-thumb"
                  />
                  <div class="team-thumb-overlay">
                    <ul class="team-social">
                      <li>
                        <Link to="#">
                          <span class="fa fa-linkedin"></span>
                        </Link>
                      </li>
                      <li>
                        <Link to="#">
                          <span class="fa fa-twitter"></span>
                        </Link>
                      </li>
                      <li>
                        <Link to="#">
                          <span class="fa fa-envelope"></span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="team-info">
                  <h5 class="team-name">David Carter</h5>
                  <span class="team-title">Finance Expert</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      {/* End Section */}

      {/* Section */}
      {/* <div class="section section-pad bg-grey">
        <div class="container">
          <div class="section-head">
            <div class="row text-center">
              <div class="col-md-6 col-md-offset-3 col-sm-8 col-sm-offset-2">
                <h2 class="heading-section">What Our Clients Say</h2>
                <p>
                  Join thousands of satisfied clients who trust us to navigate
                  the world of cryptocurrency. Their experiences speak for our
                  commitment to excellence.
                </p>
              </div>
            </div>
          </div>
          <div class="gaps size-3x"></div>
          <div class="row text-center">
            <div class="col-md-6 col-md-offset-3">
              <div
                class="testimonial-carousel has-carousel"
                data-items="1"
                data-loop="true"
                data-dots="true"
                data-auto="true"
              >
                <div class="testimonial-item">
                  <div class="client-photo circle">
                    <img
                      src={require("../../assets/images/client-a.jpg")}
                      alt="client"
                    />
                    <em class="fa fa-quote-right"></em>
                  </div>
                  <blockquote>
                    CryptoCoin has made my investment journey seamless. The team
                    is incredibly supportive, and the platform's features are
                    unmatched.
                  </blockquote>
                  <div class="client-info">
                    <h6>Emma Johnson</h6>
                    <span>Investor & Entrepreneur</span>
                  </div>
                </div>
                <div class="testimonial-item">
                  <div class="client-photo circle">
                    <img
                      src={require("../../assets/images/client-b.jpg")}
                      alt="client"
                    />
                    <em class="fa fa-quote-right"></em>
                  </div>
                  <blockquote>
                    Thanks to CryptoCoin, I’ve diversified my portfolio with
                    ease. Their insights and tools are indispensable.
                  </blockquote>
                  <div class="client-info">
                    <h6>Michael Brown</h6>
                    <span>Crypto Enthusiast</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      {/* End Section */}

      {/* Section */}
      {/* <div className="section section-pad-md">
        <div className="container">
          <div className="content row">
            <div className="clients-row">
              <div className="logo-item">
                <img
                  alt=""
                  width="190"
                  height="82"
                  src={require("../../assets/images/cl-logo1.png")}
                />
              </div>
              <div className="logo-item">
                <img
                  alt=""
                  width="190"
                  height="82"
                  src={require("../../assets/images/cl-logo2.png")}
                />
              </div>
              <div className="logo-item">
                <img
                  alt=""
                  width="190"
                  height="82"
                  src={require("../../assets/images/cl-logo3.png")}
                />
              </div>
              <div className="logo-item">
                <img
                  alt=""
                  width="190"
                  height="82"
                  src={require("../../assets/images/cl-logo4.png")}
                />
              </div>
              <div className="logo-item">
                <img
                  alt=""
                  width="190"
                  height="82"
                  src={require("../../assets/images/cl-logo5.png")}
                />
              </div>
              <div className="logo-item">
                <img
                  alt=""
                  width="190"
                  height="82"
                  src={require("../../assets/images/cl-logo6.png")}
                />
              </div>
            </div>
          </div>
        </div>
      </div> */}
      {/* End Section */}

      <Footer />
    </div>
  );
};

export default About;
